import { type AlertProps, Alert as AntdAlert } from 'antd'

export const Alert = (props: AlertProps) => <AntdAlert {...props} />
